export const isMidiKeyPressureEvent = (event) => {
    return event.keyPressure !== undefined;
};
//# sourceMappingURL=/build/es2019/guards/midi-key-pressure-event.js.map